module.exports = __webpack_public_path__ + "static/media/closetab.5df6b2ef.svg";